var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_500_917)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 11.2439C22.0001 10.3421 21.9252 9.68394 21.7632 9.00146H11.2246V13.072H17.4105C17.2858 14.0836 16.6124 15.607 15.1157 16.6307L15.0948 16.7669L18.4269 19.2894L18.6577 19.3119C20.7778 17.3985 22.0001 14.5832 22.0001 11.2439Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2245 21.9687C14.2551 21.9687 16.7993 20.9936 18.6576 19.3118L15.1156 16.6306C14.1678 17.2765 12.8957 17.7274 11.2245 17.7274C8.25627 17.7274 5.73702 15.8141 4.83897 13.1694L4.70734 13.1804L1.24258 15.8006L1.19727 15.9237C3.04305 19.5068 6.83444 21.9687 11.2245 21.9687Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.83895 13.1694C4.602 12.4869 4.46486 11.7556 4.46486 11C4.46486 10.2444 4.602 9.51315 4.82649 8.83067L4.82021 8.68532L1.31203 6.02295L1.19725 6.0763C0.436513 7.56317 0 9.23286 0 11C0 12.7672 0.436513 14.4368 1.19725 15.9236L4.83895 13.1694Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2245 4.2724C13.3322 4.2724 14.7539 5.16207 15.5646 5.90555L18.7324 2.88308C16.7869 1.11592 14.2551 0.03125 11.2245 0.03125C6.83444 0.03125 3.04305 2.49307 1.19727 6.07611L4.8265 8.83047C5.73702 6.18583 8.25627 4.2724 11.2245 4.2724Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_500_917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.95f733b73787fe9f9b43e53780fe5c60.svg";
export { ForwardRef as ReactComponent };